import {
  initialPatientDashboardState,
  SET_PATIENTS,
  SET_PATIENTS_WITHOUT_CONSENT,
  SET_PATIENTS_WITH_CONSENT,
  SHIFT_PATIENT_TO_WITH_CONSENT,
  RESET_PATIENTS_DASHBOARD,
} from './constants'

export const patientDashboardReducer = (
  state: PatientDashboardState = initialPatientDashboardState,
  // Type any is intentional here
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  action: ReducerActions<any>
): PatientDashboardState => {
  const { type: actionType, payload: actionPayload } = action

  switch (actionType) {
    case SET_PATIENTS:
      return {
        ...state,
        patients: actionPayload,
      }
    case SET_PATIENTS_WITH_CONSENT:
      return {
        ...state,
        patientsWithConsent: actionPayload,
      }
    case SET_PATIENTS_WITHOUT_CONSENT:
      return {
        ...state,
        patientsWithoutConsent: actionPayload,
      }
    case SHIFT_PATIENT_TO_WITH_CONSENT:
      const { patientsWithoutConsent, patientsWithConsent } = state
      const updatedPatientsWithoutConsent = patientsWithoutConsent.filter(
        (patient) => patient.id !== actionPayload.id //Here, action payload will be a Patient object
      )
      const updatedPatientsWithConsent = [...patientsWithConsent, actionPayload]

      return {
        ...state,
        patientsWithConsent: updatedPatientsWithConsent,
        patientsWithoutConsent: updatedPatientsWithoutConsent,
      }
    case RESET_PATIENTS_DASHBOARD:
      return initialPatientDashboardState
    default:
      return state
  }
}
